var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "projectConfig app-wrapper dream" },
    [
      _c("childNav", {
        attrs: {
          routerName: _vm.$t("updateNewSip.moduleName"),
          backFlag: true,
        },
        on: { clearCase: _vm.clearCase },
      }),
      _c(
        "div",
        { staticClass: "app-content config-body" },
        [
          _c(
            "Row",
            { staticClass: "full-box", attrs: { gutter: "20" } },
            [
              _c(
                "i-col",
                { attrs: { span: "3" } },
                [
                  _c("project-step", {
                    attrs: {
                      "step-two-class":
                        _vm.currentStep === 0 ? "step2_no" : "step2_active",
                      "step-three-class":
                        _vm.currentStep === 2 ? "step3_active" : "step3_no",
                    },
                    on: { setCurrentStep: _vm.setCurrentStep },
                  }),
                ],
                1
              ),
              _c(
                "i-col",
                { attrs: { span: "19" } },
                [
                  _c(
                    "h3",
                    { staticClass: "tip-color margin-bottom-20" },
                    [
                      _c("Icon", {
                        attrs: {
                          type: "md-information-circle",
                          ssize: "30",
                          color: "#fc7790",
                        },
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("deviceSip.saveTip")) + " "),
                    ],
                    1
                  ),
                  _vm.currentStep === 0
                    ? _c("community-config", {
                        key: _vm.timeStamp,
                        ref: "communityConfig",
                        attrs: { "current-step": _vm.currentStep },
                        on: { setCurrentStep: _vm.setCurrentStep },
                      })
                    : _vm._e(),
                  _vm.currentStep === 1
                    ? _c("area-config", {
                        key: _vm.timeStamp,
                        ref: "areaConfig",
                        attrs: { "current-step": _vm.currentStep },
                        on: { setCurrentStep: _vm.setCurrentStep },
                      })
                    : _vm._e(),
                  _vm.currentStep === 2
                    ? _c("device-config", {
                        ref: "deviceConfig",
                        attrs: { "current-step": _vm.currentStep },
                        on: { setCurrentStep: _vm.setCurrentStep },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }